export default __webpack_public_path__ + "static/media/customizedLeaseDraftingIcon.5382719c.svg";